<template>
  <div class="filterbox" data-aos="fade-in-right">
    <p class="closebtn">
      <CloseIcon
        class="CloseIcon"
        v-on:click="ExitFilter"
      />
    </p>

    <IndusturyFilter />
  </div>
</template>
<script>
import CloseIcon from "../svgs/CloseIcon.vue";
import IndusturyFilter from "./IndusturyFilter.vue";
export default {
  props:{
    test:String
  },
  data() {
    return {
      
    };
  },

  methods: {
    ExitFilter() {
      this.$emit('exit' , false)
    },
  },
  components: { CloseIcon, IndusturyFilter },
};
</script>
<style scoped>
.filterbox {
  width: 90%;
  height: 100vh;
  position: absolute;
  top: 0;
  right: 0;
  background-color: #eee;
  box-shadow: 0 10px 10px gray;
  z-index: 100;
}

.closebtn {
  text-align: left;
  margin: 1rem;
  cursor: pointer;
}
.closebtn:hover .CloseIcon {
  animation: CloseBtnRotate 1s infinite;
}

@keyframes CloseBtnRotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>